import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { TokenService } from '@app/shared/services/token.service';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { filter, map, take, timeout, catchError } from 'rxjs';
import { of } from 'rxjs';

export function authGuard(...permissions: string[]): CanActivateFn {
  return (req, state) => {
    const tokenService = inject(TokenService);
    const userAuthService = inject(UserAuthService);
    const router = inject(Router);
    
    // Check if user is logged in first
    if (!tokenService.isLogged()) {
      // Store the attempted URL for redirect after login
      sessionStorage.setItem('redirectUrl', state.url);
      return router.parseUrl('/');
    }
    
    return userAuthService.isInitalLoadComplete$.pipe(
      filter(loaded => loaded),
      take(1),
      timeout(5000), // Add timeout to prevent infinite waiting
      map(() => {
        // If no permissions required, allow access
        if (!permissions || permissions.length === 0) {
          return true;
        }
        
        // Check if user has any of the required permissions
        const hasPermission = permissions.some(permission => 
          userAuthService.checkPermission(permission)
        );
        
        if (hasPermission) {
          return true;
        }
        
        // User doesn't have permission
        return router.parseUrl('release/insufficient-permission');
      }),
      catchError(() => {
        // If timeout or error, redirect to login
        return of(router.parseUrl('/'));
      })
    );
  };
}
